import Footer from "components/footer";
import GetStarted from "components/getStarted";
import Navbar from "components/navbar/landingPage-navabar";
import React, { useEffect } from "react";
import styled from "styled-components";
import Header from "./components/header";
import Why from "./components/why";
import MissionVision from "./components/missonVision";
import ContactUs from "components/contact-us";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <Container>
      <Navbar />
      <Header />
      <Why />
      <MissionVision />
      <ContactUs />
      <GetStarted />
      <Footer />
    </Container>
  );
};

export default AboutUs;

const Container = styled.main`
  /* overflow-x: hidden; */
`;
